'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';
import categorySelect from '../../components/form/element/category/select';

export class StorageComponent {

  closeWindow: Function;

  data;
  storage;
  modules;
  module;

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.module   = this.data.module;
    this.modules  = this.data.modules;
    this.storage  = this.data.storage || {
      categoryId: this.data.category ? this.data.category._id : undefined
    };
  }

  save() {
    return this.Storage.saveStorage(this.storage)
      .then(() => this.close())
      .catch(err => console.error(err));
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.storage', [
    categorySelect,
  ])
  .component('storage', {
    bindings: {data: '='},
    transclude: true,
    template: require('./storage.html'),
    controller: StorageComponent,
    controllerAs: 'storageCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/storage/storage.component.js